app.service('cartManager', function ($global, broker, console, cartBox, cookie, loading, modal, front, log) {
	var addedPartnerSubscriptions = [];

	function addToCartFromInstalment(productId, instalment, instalmentNumber, paymentType, delivery, addedFrom, productPlu, outletCategoryId, warranty, warrantyAddedFrom) {
		addProduct({
			productId: productId,
			productPLU: productPlu,
			isInstalment: true,
			instalment: instalment,
			instalmentNumber: instalmentNumber,
			paymentType: paymentType,
			delivery: (delivery ? delivery : 'HOME'),
			addedFrom: addedFrom,
			outletCategoryId,
			warranty: warranty,
			warrantyAddedFrom
		});
	}
	function warrantyAction(ajaxData, callback) {
		if (ajaxData.warrantyId || ajaxData.mainCartItemId) {
			loading.start();
			$.ajax({
				url: '/cart-item-operation.ltr',
				method: 'post',
				data: ajaxData,
				cache: false,
				success: function (json) {
					console.log('GWARANCJA - ' + ajaxData.action + ' - OK');
					if (typeof callback === "function") {
						callback();
					} else {
						loading.stop();
					}
				},
				error: function () {
					console.log('GWARANCJA - ' + ajaxData.action + ' - OK');
				}
			});
		}
	}
	function addServiceWithProduct(serviceId, productId) {
		var input = $('#services-list input[value=' + serviceId + ']');
		if (!input.is(':checked')) {
			input.attr('checked', true);
		}
		addProduct({ productId: productId });
	}
	function removeProduct(option, success, logEventData = {}) {
		UA.removeFromCart(option.productId);
		if (logEventData) {
			log.event(logEventData);
		}
		loading.start();
		$.ajax({
			url: '/remove-product-from-cart.ltr',
			method: 'POST',
			cache: false,
			data: option,
			success: function () {
				loading.stop();
				console.log('USUNIETO Z KOSZYKA: ' + option.productId);
				cartBox.refresh();
				if ($.isFunction(success)) {
					success();
				}
			}, error: function () {
				loading.stop();
				console.log('USUNIETO Z KOSZYKA - ERROR');
			}
		});
	}
	function simpleAddProduct(option, success, logEventData = {}) {
		var data = {
			addedFrom: '',
			toCart: false
		};
		$.extend(true, data, option);
		if (logEventData) {
			log.event(logEventData);
		}
		UA.addToCart(data.productId);
		loading.start();
		$.ajax({
			url: '/add-product-to-cart.ltr',
			method: 'POST',
			cache: false,
			data: data,
			success: function (json) {
				loading.stop();
				if (json.status == 'SUCCESS') {
					console.log('DOODANO DO KOSZYKA: ' + data.productId);
					cartBox.refresh();
					if ($.isFunction(success)) {
						success();
					}
				} else {
					modal.alert(json.reason);
					cartBox.refresh();
				}
			}, error: function () {
				loading.stop();
				console.log('DOODANO DO KOSZYKA - ERROR');
			}
		});
	}
	function modalAdded(text, option) {
		console.log('modalAdded: ' + text);
		modal.generate({
			header: text,
			id: 'added-product',
			buttons: [
				{
					text: 'Przejdź do koszyka',
					cssClass: 'btn-primary',
					click: function () {
						loading.redirect('/cart.bhtml');
					}
				},
				{
					text: 'Kontynuuj zakupy',
					cssClass: 'btn-second',
					click: function () {
						modal.close();
					}
				}
			]
		});
	}
	function addToCardSuccess(data, json) {
		let lastAjaxData = $.extend(true, data, json);
		if (lastAjaxData.redirectUrl) {
			loading.redirect(lastAjaxData.redirectUrl);
		} else {
			cartBox.refresh();
			modalAdded('Dodano do koszyka: <strong>' + lastAjaxData.justAdded + '</strong>');
		}
	}
	function addProductLogEvent(options) {
		log.event({
			id: 'tocart',
			f03: options.addedFrom,
			f04: options.productPLU,
			f05: options.instalment ? 'raty' : '',
			f06: '',
			f07: front.page()
		});
		let toCartEventData = {
			id: 'to_cart',
			f03: options.addedFrom,
			f04: options.productPLU,
			f05: 'product',
			f06: '',
			f07: 'leaf',
			f08: 'button',
			f09: options.outletState ? 'outlet' : 'new',
			f10: options.isInstalment ? 'installment' : 'cash',
		}
		if(options.addedFrom && options.addedFrom == 'COMPARASION'){
			toCartEventData.f03 = 'comparison';
		}
		if(front.page() == 'article'){
			toCartEventData.f03 = 'articles';
		}

		log.event(toCartEventData);
		if (options.addedFrom && options.addedFrom == 'PRODUCT_CARD') {
			if (options.services && options.services.length) {
				log.event({
					id: 'Sekcja_uslug' + (options.instalment ? '_raty' : ''),
					f03: document.location.href,
					f04: options.services.join(',')
				});
			}
			if (options.partnerSubscriptionsIds && options.partnerSubscriptionsIds.length) {
				log.event({
					id: 'Sekcja_uslugi_partnerskie' + (options.instalment ? '_raty' : ''),
					f03: document.location.href,
					f04: options.partnerSubscriptionsIds.join(',')
				});
			}
			if (options.warranty && options.warrantyPaymentType) {
				log.event({
					id: 'Sekcja_gwarancji' + (options.instalment ? '_raty' : ''),
					f03: document.location.href,
					f04: options.warrantyPaymentType == 'POSTPONED' ? 'Płatność miesięczna' : 'Płatność jednorazowa',
					f05: options.warranty
				});
			}
		}
	}
	function addProduct(options) {
		function checkServices() {
			console.log('ZLICZENIE USŁUG');
			var services = [];
			$('#services-list input[type=checkbox]:checked').each(function () {
				services.push($(this).val());
			});
			return services;
		}
		function checkWarranties() {
			console.log('ZLICZENIE GWARANCJI');
			$checkedWarranty = $('#warranties-list input[type=checkbox]:checked');

			if (!$checkedWarranty.length) return false;

			return {
				warranty: $checkedWarranty.val(),
				warrantyPaymentType: $checkedWarranty.data('warranty-payment-type'),
				warrantyAddedFrom: $checkedWarranty.data('warranty-added-from') || 'PRODUCT_CARD_WARRANTY_SECTION'
			};
		}
		function checkPartnerSubscriptions() {
			if (addedPartnerSubscriptions.length) {
				return addedPartnerSubscriptions.map(function (n) {
					return n.split("|")[0];
				})
			}
			return false;
		}
		loading.start();
		console.log('ROZPOCZĘCIE DODAWANIA DO KOSZYKA');
		var url = '/addToCartJsonTool.ltr';
		log.recommendationsForAWS({
			productPlu: options.productPLU,
			eventCategory: options.addedFrom,
			eventAction: 'Dodanie do koszyka'
		});
		var data = {};
		data.productId = options.productId;
		if (options.outletCategoryId) {
			data.outletCategoryId = options.outletCategoryId;
		}
		if (options.outletProductId !== undefined) {
			data.outletProductId = options.outletProductId;
		}
		if (options.button) {
			data.button = options.button;
		}
		if (options.outletState) {
			UA.addToCart(data.productId, {
				dimension45: 'Outlet',
				dimension46: options.outletState
			});
		} else {
			UA.addToCart(data.productId, {
				dimension45: 'Nowy',
				dimension46: 'Nowy'
			});
		}
		data.services = checkServices();
		if (checkPartnerSubscriptions()) {
			data.partnerSubscriptionsIds = checkPartnerSubscriptions();
		}
		if (options.delivery) {
			data.delivery = options.delivery;
		}
		if (options.addedFrom) {
			data.addedFrom = options.addedFrom;
		}

		if (options.productPLU) {
			if (front.page() === 'product-card') {
				UA.doubleClick(options.productPLU, 'dc-prod-tocart-kp');
			}
			if (front.page() === 'comparison') {
				UA.doubleClick(options.productPLU, 'dc-tocart-sp');
			}
			data.productPLU = options.productPLU;
		}

		if (options.relatedPromotionServiceId) {
			url = '/add-related-promotion-to-cart.ltr';
			if (options.replaceProduct) {
				data.replaceProduct = true;
			}
			data.relatedPromotionServiceId = options.relatedPromotionServiceId;
		}
		if (options.paymentType) {
			data.paymentType = options.paymentType;
		}
		data.cartCookie = cookie.get("euroCart");
		if (options.shopCode) {
			data.shopCode = options.shopCode;
		}
		if (options.warranty !== undefined) {
			data.warranty = options.warranty;
		}
		if (options.warranty === undefined && checkWarranties()) {
			const { warranty, warrantyPaymentType, warrantyAddedFrom } = checkWarranties();
			data.warranty = warranty;
			data.warrantyPaymentType = warrantyPaymentType;
			data.warrantyAddedFrom = warrantyAddedFrom;
		}
		if (options.warrantyAddedFrom) {
			data.warrantyAddedFrom = options.warrantyAddedFrom;
		}
		if (options.isInstalment) {
				data.isInstalment = options.isInstalment;
			}
			if (options.instalment) {
			data.instalment = options.instalment;
		}
		if (options.instalmentNumber) {
			data.instalmentNumber = options.instalmentNumber;
		}
		if (options.showWarrantyEncouragement !== undefined) {
			data.showWarrantyEncouragement = options.showWarrantyEncouragement;
		}
		if (options.toCartViewEnabled !== undefined) {
			data.toCartViewEnabled = options.toCartViewEnabled;
		}
		if (options.voucherCode !== undefined) {
			data.voucherCode = options.voucherCode;
		}
		addProductLogEvent(data);
		$.ajax({
			url: url,
			dataType: 'json',
			async: false,
			cache: false,
			data: data,
			type: 'POST',
			success: function (json) {
				console.log('DODAWANIE DO KOSZYKA - OK');
				loading.stop();
				if (json.addToCartPossible) {
					if (json.blockedCountry) {
						UA.interaction('Geoblocking', 'Unlocked', 'Cart');
					}
					addToCardSuccess(data, json);
				} else {
					if (json.blacklistConflict && json.cannotAddProductReasons) {
						let content = json.cannotAddProductReasons.map(function (e) { return '<li>' + e + '</li>' }).join("");
						modal.generate({
							id: 'cannot-add-product-reasons',
							content: `<h2>Produkt nie został dodany do koszyka</h2><p>Wybrany element <span>${json.justAdded}</span> nie pasuje do elementów znajdujących się już w koszyku.</p><p><strong>Prosimy o zwracanie uwagi na:</strong></p><ul>${content}</ul>`,
							buttons: [
								{
									text: "Ok",
									cssClass: 'btn-primary',
									click: function () {
										modal.close();
									}
								}
							]
						});
					} else {
						modal.alert(json.cannotAddProductMessage);
						if (json.blockedCountry) {
							UA.interaction('Geoblocking', 'Locked', 'Cart');
						} else if (options.outletState) {
							UA.interaction('Komunikat błędu', 'Outlet', 'Stan produktu', false);
						}
					}
				}
			}, error: function () {
				loading.stop();
				modal.alert('Operacja nie udała się. Odśwież stronę i spóbuj ponownie. Jeśli błąd sie powtórzy, prosimy zgłoś go obsłudze sklepu.');
			}
		});
	}

	function addDynamicSuite(productId, packageElements) {
		loading.start();

		let data = {
			productId,
			packageElements
		};

		$.ajax({
			url: "/add-product-package-to-cart.ltr",
			method: "POST",
			data
		}).then(response => {
			if (response.addToCartPossible) {
				addToCardSuccess(response, data)
			} else {
				modal.alert(response.cannotAddProductMessage);
			}
		})
			.fail(() => modal.alert("Błąd dodawania zestawu do koszyka."))
			.always(() => loading.stop());
	}

	function checkRelatedProducts() {
		var items = cartBox.getElements();
		$('input[name=accessory]').each(function () {
			var $element = $(this);
			var checked = $.inArray(parseInt($element.val()), items) > -1;
			$element.prop('checked', checked);
		});
	}

	function getAddedPartnerSubscriptions() {
		return [].concat(addedPartnerSubscriptions);
	}

	function addPartnerSubscription(options) {
		loading.start();
		$.ajax({
			url: '/add-partner-subscriptions-to-cart.ltr',
			method: 'POST',
			dataType: 'json',
			data: {
				productId: options.productId,
				partnerSubscriptionId: options.partnerSubscriptionId,
				relatedPromotionIdentifier: options.relatedPromotionIdentifier,
				cartCookie: cookie.get("euroCart")
			}, success: function (json) {
				loading.stop();
				if (json.status == 'FAIL') {
					modal.alert(json.messages);
				} else {
					if (front.page() === 'basket') {
						loading.reload();
					} else {
						cartBox.refresh();
					}
				}
			}, error: function () {
				modal.alert('Błąd dodawania usług partnerskich')
			}
		});
	}

	function removePartnerSubscription(options) {
		cartBox.abortRefresh();
		$.ajax({
			url: '/remove-partner-subscription.ltr',
			method: 'POST',
			dataType: 'json',
			data: {
				partnerSubscriptionId: options.partnerSubscriptionId,
				productId: options.productId,
				relatedPromotionIdentifier: options.relatedPromotionIdentifier
			},
			cache: false,
			complete: function (json) {
				if (json.responseJSON && json.responseJSON.status == 'FAIL') {
					modal.alert(json.messages);
				} else {
					if (front.page() === 'basket') {
						loading.reload();
					} else {
						cartBox.refresh();
					}
				}
			}
		});
	}

	function updatePartnerSubscriptionQuantity(options) {
		$.ajax({
			url: '/cart-update-partner-subscription-quantity.ltr',
			method: 'POST',
			dataType: 'json',
			data: {
				partnerSubscriptionId: options.partnerSubscriptionId,
				relatedPromotionIdentifier: options.relatedPromotionIdentifier,
				productId: options.productId,
				quantity: options.quantity
			},
			cache: false,
			complete: function (json) {
				if (json.responseJSON && json.responseJSON.status == 'FAIL') {
					modal.generate({
						id: 'standalone-service-message',
						content: '<p>' + json.responseJSON.messages + '</p>',
						callbackClose: function () {
							loading.reload();
						},
						buttons: [
							{
								text: 'Rozumiem',
								click: function () {
									modal.close();
								},
								cssClass: 'btn btn-second'
							}
						]
					});
				} else {
					loading.reload();
				}
			}
		});
	}

	function updatePartnerSubscriptionStandaloneServiceQuantity(options) {
		loading.start();
		$.ajax({
			url: '/cart-update-partner-subscription-standalone-service-quantity.ltr',
			method: 'POST',
			dataType: 'json',
			data: {
				productId: options.productId,
				quantity: options.quantity,
				relatedPromotionIdentifier: options.relatedPromotionIdentifier
			},
			cache: false,
			success: function (json) {
				loading.stop();
				if (json && json.status == 'FAIL') {
					modal.generate({
						id: 'standalone-service-message',
						content: '<p>' + json.messages + '</p>',
						callbackClose: function () {
							loading.reload();
						},
						buttons: [
							{
								text: 'Rozumiem',
								click: function () {
									modal.close();
								},
								cssClass: 'btn btn-second',
							}
						]
					});
				} else {
					loading.reload();
				}
			}, error: function () {
				loading.stop();
				modal.alert('Wystąpił błąd zmiany ilości. Spróbuj ponownie')
			}
		});
	}

	function savePartnerSubscriptions(options) {
		var element = options.partnerSubscription + '|' + options.group;
		if (options.checked) {
			addedPartnerSubscriptions.push(element);
		} else {
			addedPartnerSubscriptions.splice(addedPartnerSubscriptions.indexOf(element), 1);
		}
	}

	broker.on('ADD_TO_CART_BY_PLU', (e, params) => {
		const { productPlu } = params;

		convertProductPluToProductId(productPlu)
			.then(productId => {
				const productToAddData = $.extend(params, productId);

				addProduct(productToAddData);
			});
	});
	broker.on('ADD_PRODUCT_TO_CART', (e, params) => {
		addProduct(params);
	});

	window.addToCartByPlu = params => {
		broker.trigger('ADD_TO_CART_BY_PLU', [params]);
	};

	$global('simpleAddProduct', simpleAddProduct);
	$global('addProduct', addProduct);
	return {
		addProduct,
		simpleAddProduct,
		removeProduct,
		addServiceWithProduct,
		warrantyAction,
		refresh: cartBox.refresh,
		getElements: cartBox.getElements,
		getServices: cartBox.getServices,
		getWarranty: cartBox.getWarranty,
		getPartnerSubscriptions: cartBox.getPartnerSubscriptions,
		savePartnerSubscriptions,
		getAddedPartnerSubscriptions,
		addPartnerSubscription,
		removePartnerSubscription,
		updatePartnerSubscriptionQuantity,
		updatePartnerSubscriptionStandaloneServiceQuantity,
		addToCartFromInstalment,
		checkRelatedProducts,
		addDynamicSuite
	};
});
